export default {
	state: {
		campanhas_ativas: {}
	},
	getters: {
		"campanhas_ativas": state => state.campanhas_ativas
	},
	mutations: {
		setCampanhasAtivas(state, payload) {
			state.campanhas_ativas = payload
		}
	},
	actions: {
		atualizarEstadoCampanhasAtivas({ commit }, payload) {
			commit('setCampanhasAtivas', payload)
		}
	}
};